module.exports = __webpack_public_path__ + "static/img_9621-6d1966d1752578d374f855cdbdcd0c26.webp";